import { Box, Button, DialogActions, DialogContent, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import { orderStatusFormatted } from "src/constant";
import useAppGlobal from "src/context/useAppGlobal";
import useOrderConfirmAllTS from "src/hooks/orders/useOrderConfirmAllTS";
const status = [
  { id: orderStatusFormatted.Delivered, title: "Giao thành công" },
  { id: orderStatusFormatted.DeliveredFailed, title: "Giao hàng không thành công" },
  { id: orderStatusFormatted.Lost, title: "Thất lạc" },
];
export default function OrderDeliveringConfirmAll({ orderIds, whouseId }) {
  const { closeDialog } = useAppGlobal();
  const [deliveringStatus, setDeliveringStatus] = useState({ status: status[0].id });
  const { trigger: confirmAll } = useOrderConfirmAllTS();

  const handleConfirmAll = async () => {
    const res = await confirmAll({
      body: {
        orderIds: orderIds,
        trackingStatus: deliveringStatus?.status,
        returnReason: deliveringStatus?.returnReason,
        warehouse: whouseId,
      },
    });
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message ?? "Lỗi khi xác nhận giao hàng", { variant: "error" });
    }
  };
  return (
    <>
      <DialogContent>
        <Box>
          <FormControl>
            <FormLabel id="demo-radio-buttons-group-label">Xác nhận trạng thái giao</FormLabel>

            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
              onChange={(e) => setDeliveringStatus((prev) => ({ ...prev, status: e.target.value }))}
            >
              {status.map((v) => {
                return (
                  <FormControlLabel
                    checked={deliveringStatus.status === v.id}
                    value={v.id}
                    control={<Radio />}
                    label={v.title}
                  />
                );
              })}
            </RadioGroup>
          </FormControl>
        </Box>
        <Box mt="12px">
          <TextField
            disabled={deliveringStatus.status !== orderStatusFormatted.DeliveredFailed}
            onChange={(e) => setDeliveringStatus((prev) => ({ ...prev, returnReason: e.target.value }))}
            fullWidth
            multiline
            rows={6}
            label="Lý do giao hàng không thành công"
            placeholder="Ví dụ: Người nhận không nghe máy..."
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: "0px 12px 24px" }}>
        <Button
          onClick={handleConfirmAll}
          fullWidth
          variant="contained"
        >
          Xác nhận
        </Button>
      </DialogActions>
    </>
  );
}
